import { useState } from "react";
import { EmailLog } from "./EmailLog";
import { Inbox } from "./Inbox";
import { Chips, PageHead } from "./ui";

export default function Messages() {
  const [tab, setTab] = useState("inbox");
  return (
    <div data-testid="admin-messages">
      <PageHead eyebrow="Messages" title={tab === "inbox" ? "Customer inbox" : "Emails sent"} />
      <Chips options={[["inbox", "Customer inbox"], ["sent", "Emails sent"]]} value={tab} onChange={setTab} testPrefix="messages-tab" />
      {tab === "inbox" ? <Inbox /> : <EmailLog />}
    </div>
  );
}
